import configHandler from '../../configHandler'

const ERROR_INVALID_LAST_NAME = 'invalidLastName'

const parse = (text) => {

    return {
        input: text,
        isRequired: false,

        required: function () {
            this.isRequired = true
            return this
        },

        parsed: function () {
            return this.input.replace(/\s+/g, ' ').trim()
        },

        isValid: function () {
            return this.validate().length === 0
        },

        validate: function () {
            const errors = []
            const parsed = this.parsed()
            if (parsed.length === 0) {
                if (this.isRequired) {
                    errors.push(configHandler.errorMessages().text[ERROR_INVALID_LAST_NAME])
                }
                return errors
            }

            const regex = /^[A-zÀ-ȕ'’‘]*((-|\s)*[A-zÀ-ȕ'’‘])*$/
            if (regex.exec(parsed) === null) {
                errors.push(configHandler.errorMessages().text[ERROR_INVALID_LAST_NAME])
            }
            return errors
        },

        value: function () {
            return String(this.input)
        },

        format: function () {
            return String(this.parsed())
        },
    }
}

export default {
    parse,
}